// extracted by mini-css-extract-plugin
module.exports = {"sectionF":"SectionF_sectionF__AulsJ"};